/**
 * モーダル表示のスクロール制御用
 */
export const disableScroll = () => document.body.classList.add('noScroll');
/**
 * モーダル表示のスクロール制御用
 */
export const enableScroll = () => document.body.classList.remove('noScroll');
